module.exports = __webpack_public_path__ + "static/img/charge.05dba1ad.gif";